import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

const useShipmentRoutingSettings = (fieldName) => {
  const customerRoutingsSettings = useSelector((state) => state.shipment.customerRoutingsSettings, shallowEqual);
  const havingAccessForMenu = useMemo(
    () => customerRoutingsSettings?.data?.[fieldName] === 'Y',
    [customerRoutingsSettings],
  );

  return !customerRoutingsSettings?.data || customerRoutingsSettings?.progressing || customerRoutingsSettings?.error
    ? false
    : havingAccessForMenu;
};

export default useShipmentRoutingSettings;
